export function createHeader({ apikey, idToken }) {
    if (apikey) {
        return {
            Authorization: `bearer ${apikey}`,
        };
    }
    if (idToken) {
        return {
            Authorization: `bearer ${idToken}`,
        };
    }
    return {};
}
